import script from "./esInstituteForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esInstituteForm.vue?vue&type=script&setup=true&lang=ts"

import "./esInstituteForm.vue?vue&type=style&index=0&id=00f8860e&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f8860e"]])

export default __exports__